import { CallApiOptions } from './api';
export const storyPublishCallOptions = (
  appConfigId: number,
  storyId: number
): CallApiOptions => {
  return {
    method: 'PUT',
    endpoint: `stories/${storyId}/app-configs/${appConfigId}/publish`,
  };
};

export const storyUnPublishCallOptions = (
  appConfigId: number,
  storyId: number
): CallApiOptions => {
  return {
    method: 'PUT',
    endpoint: `stories/${storyId}/app-configs/${appConfigId}/unpublish`,
  };
};



// WEBPACK FOOTER //
// ./src/services/story-publish.services.ts